import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMaskInput } from 'react-imask';
import { fromJS } from 'immutable';

import Loading from './Loading';
import MerchantRecord from '../../records/merchant';
import Network from '../../lib/network';
import Support from './Support';
import Term from './Term';
import { daysAsMonths } from '../../lib/formatters';
import { server } from '../../constants/SiteVariables';
import { updateParent } from '../../lib/modal';

import logo from '../../images/ck-nav-logo-2022.svg';

const api = Network();

export default function ProductDisplayPage({ match }) {
  const [loading, setLoading] = useState(true);
  const [approvedTerms, setApprovedTerms] = useState([]);
  const [merchant, setMerchant] = useState(null);
  const publicKey = match.params.public_key;

  const chargesFromStr = match.params.charges.split(',');
  const chargesObj = {
    data: {
      total: parseInt(chargesFromStr[0]).toString(),
      shipping: parseInt(chargesFromStr[1]).toString(),
      tax: parseInt(chargesFromStr[2]).toString(),
      discount_amount: 0,
      grand_total: parseInt(chargesFromStr[3]).toString()
    }
  }
  const [charges, setCharges] = useState(chargesObj);

  useEffect(() => {
    api.post({
      resource: 'ecomm/marketing'
    }, {
      public_key: publicKey,
      charges: charges,
      enhanced: true
    })
    .then(res => {
      setMerchant(new MerchantRecord(fromJS(res.merchant)));
      setApprovedTerms(fromJS(res.approved_terms));
      setLoading(false);
    });
  }, [charges]);

  const onChange = value => {
    chargesObj.data.grand_total = value;

    setCharges(chargesObj);
  }

  const dismiss = () => {
    return updateParent('cancel', null);
  }

  if (!publicKey && !charges) {
    return (<div id="content">
      <Support />
    </div>);
  }

  if (loading) return (<Loading active={true} />);

  return (
    <div id="content">
      <nav className="header box is-shadowless level is-mobile">
        <div className="level-left">
          <div className="level-item">
            <a className="is-size-5" onClick={dismiss}><FontAwesomeIcon icon={['fal', 'times']} /></a>
          </div>
        </div>

        <div className="level-item">
          <img src={logo} />
        </div>

        <div className="level-right">
          <div className="level-item">
            <a className="is-size-5" href="#" target="_new"><FontAwesomeIcon icon={['fal', 'question-circle']} /></a>
          </div>
        </div>
      </nav>

      <div id="main-content" className="container">

        <div className="has-text-centered">
          <div className="is-size-4 has-text-weight-bold" style={{ lineHeight: '2rem' }}>Easy monthly terms for business purchases</div>
          {merchant.active_promo.get('max_net_payment') > 30 ?
            <><div className="mt-3 text-green-highlight is-size-2">No payments for {merchant.active_promo.get('max_net_payment')} days</div> <strong>No early pay-off fees.</strong></> :
            <div className="mt-3 text-green-highlight is-size-2">0% for {daysAsMonths(merchant.active_promo.get('max_net_duration'))}</div>}

          <div>Approvals in seconds</div>
          <div>Checking your rate will <strong>not</strong> affect your credit</div>

          <div className="my-3 has-text-weight-semibold form-inline">
            <label htmlFor="amount">Sample rates for a</label>
            <IMaskInput
              id="amount"
              name="amount"
              size="8"
              mask="$num"
              unmask={true}
              blocks={{
                num: {
                  mask: Number,
                  scale: 0
                }
              }}
              onComplete={onChange}
              value={charges.data.grand_total}
            />
            <label>purchase</label>
          </div>
        </div>

        {approvedTerms.filter(i => i.get('available')).map((d, idx) => {
          return (<Term
            key={idx}
            index={idx}
            merchant={merchant}
            term={d}
          />)
        })}

        {match.params.type !== 'cart' && <a
          href={server() + '/apply/' + merchant.slug}
          target="_new"
          className={classNames('button is-primary is-large is-fullwidth has-text-weight-bold mt-5', {
            'is-loading': loading
          })}>
          See if you qualify
        </a>}

        {match.params.type !== 'cart' && <div className="mt-3 mb-3 has-text-weight-bold has-text-centered">
          <a href={merchant.learn_more_link} target="_new">Learn More</a>
        </div>}
      </div>

      <div className="has-text-centered mb-3">
        <Support />
      </div>
    </div>
  );
}
